import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

interface ActivateParams {
  id: string;
}

const useActivate = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ id }: ActivateParams) => {
      const response = await Api.Activate(id);
      return response.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['test', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['test', 'single', variables.id] });
      toast.success('Success', { description: 'Test activated successfully' });
    },
    onError: (error: unknown) => {
      const message = error && typeof error === 'object' && 'response' in error
        ? (error as { response?: { data?: { message?: string } } }).response?.data?.message
        : 'Failed to activate test';
      toast.error('Error', { description: message });
    },
  });
};

export default useActivate;
